var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernmentBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,14h1c.553,0,1-.447,1-1s-.447-1-1-1H2.3c-.166,0-.3-.135-.3-.3,0-.109.06-.21.156-.263l8.451-4.609c.121-.065.257-.101.393-.101s.272.035.392.1l6.13,3.344c.151.083.315.122.478.122.354,0,.697-.188.879-.521.265-.484.086-1.092-.399-1.356l-6.13-3.345c-.11-.06-.231-.092-.348-.136v-.737l2.504-1.688c.427-.288.363-.935-.113-1.133L11.262.071c-.6-.25-1.262.191-1.262.841v4.022c-.117.045-.239.077-.35.137L1.199,9.682c-.739.403-1.199,1.177-1.199,2.019,0,1.166.875,2.121,2,2.269v8.03h-1c-.552,0-1,.447-1,1s.448,1,1,1h9c.552,0,1-.447,1-1s-.448-1-1-1h-2v-8h2v1c0,.553.448,1,1,1s1-.447,1-1v-1Zm-6,8h-2v-8h2v8Zm13.642-7.692c.274-.297.536-.625.741-.974.346-.59-.115-1.333-.799-1.333h-3.167c-.684,0-1.144.743-.799,1.333.204.349.466.677.741.974-2.376.879-4.358,3.52-4.358,6.204,0,1.924,1.57,3.488,3.5,3.488h5c1.93,0,3.5-1.564,3.5-3.488,0-2.684-1.982-5.325-4.358-6.204Zm.858,7.692h-5c-.827,0-1.5-.668-1.5-1.488,0-2.192,2.056-4.512,4-4.512s4,2.319,4,4.512c0,.82-.673,1.488-1.5,1.488Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentBudget);
export default __webpack_public_path__ + "static/media/government-budget.fd43b9bc43e452e2c2204903b031d322.svg";
export { ForwardRef as ReactComponent };